import s from './added-product-card.module.css'
import Image from 'next/image'
import Link from 'next/link'
import type { Product } from 'types/Product'

export default function AddedProductCard(product: Product.Product) {
    const priceFormatter = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  })
  const formattedPrice = priceFormatter.format(product.price.value);
  return (
    <Link href={`/products/${product.path}`}>
      <div key={product.id} className={s.upgradeProductCard}>
        <div className={s.imageContainer}>
          <Image
            src={product.images[0]?.url}
            alt={product.images[0]?.alt || product.name}
            width={75}
            height={75}
          />
        </div>
        <div className={s.productDetails}>
          <div className={s.title}>{product.name}</div>
          <div className={s.price}>{formattedPrice}</div>
        </div>
      </div>
    </Link>
  )
}
